/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePayPeriodSummary } from './EmployeePayPeriodSummary';
import {
    EmployeePayPeriodSummaryFromJSON,
    EmployeePayPeriodSummaryFromJSONTyped,
    EmployeePayPeriodSummaryToJSON,
    EmployeePayPeriodSummaryToJSONTyped,
} from './EmployeePayPeriodSummary';

/**
 * 
 * @export
 * @interface ShowEmployeePayPeriodSummaryResponse
 */
export interface ShowEmployeePayPeriodSummaryResponse {
    /**
     * 
     * @type {EmployeePayPeriodSummary}
     * @memberof ShowEmployeePayPeriodSummaryResponse
     */
    data: EmployeePayPeriodSummary;
}

/**
 * Check if a given object implements the ShowEmployeePayPeriodSummaryResponse interface.
 */
export function instanceOfShowEmployeePayPeriodSummaryResponse(value: object): value is ShowEmployeePayPeriodSummaryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowEmployeePayPeriodSummaryResponseFromJSON(json: any): ShowEmployeePayPeriodSummaryResponse {
    return ShowEmployeePayPeriodSummaryResponseFromJSONTyped(json, false);
}

export function ShowEmployeePayPeriodSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEmployeePayPeriodSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePayPeriodSummaryFromJSON(json['data']),
    };
}

  export function ShowEmployeePayPeriodSummaryResponseToJSON(json: any): ShowEmployeePayPeriodSummaryResponse {
      return ShowEmployeePayPeriodSummaryResponseToJSONTyped(json, false);
  }

  export function ShowEmployeePayPeriodSummaryResponseToJSONTyped(value?: ShowEmployeePayPeriodSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePayPeriodSummaryToJSON(value['data']),
    };
}

